import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { OtherRoutingModule } from './other-routing.module';
import { NWMControls } from 'app/components/Controls/NWMControls.module';
import { OtherComponent } from './other.component';
import { SupportComponent } from './support.component';
import { FaqComponent } from './faq.component';

@NgModule({
    imports: [
        BrowserModule,
        RouterModule,
        OtherRoutingModule,
        NWMControls,
        SupportComponent,
        FaqComponent,
        OtherComponent
    ],
    providers: []
})
export class OtherModule{}